import { render, staticRenderFns } from "./BarEchart.vue?vue&type=template&id=6c479f23"
import script from "./BarEchart.vue?vue&type=script&lang=js"
export * from "./BarEchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports